/*
  LZX Pesca — orçamento com vários itens.

  Um carrinho sem carrinho. A loja é de atacado, não tem preço nem checkout,
  e o único caminho de conversão é o WhatsApp. O problema que isso cria: um
  lojista repondo estoque quer doze itens, e hoje cada botão abre uma
  conversa nova. Ou ele manda doze mensagens, ou desiste e digita tudo na
  mão, torto, com a medida errada.

  Aqui ele vai marcando enquanto navega e, no fim, uma mensagem só sai com
  produto, medida e quantidade de cada linha. O vendedor recebe um pedido
  pronto para cotar.

  Fica no navegador dele (localStorage), sem cadastro e sem servidor: dá
  para montar hoje e enviar amanhã. E como não há preço envolvido, não há
  nada que possa ficar desatualizado enquanto espera.
*/

(function () {
  'use strict';

  var CHAVE = 'lzx-orcamento';
  var LIMITE = 40;

  /* ---------------- Armazenamento ---------------- */

  /*
    Navegação anônima e armazenamento bloqueado fazem localStorage lançar
    exceção em vez de devolver vazio. O orçamento é um conforto, não a
    função principal do site: se não der para guardar, o resto continua de pé.
  */
  function ler() {
    try {
      var bruto = window.localStorage.getItem(CHAVE);
      var lista = bruto ? JSON.parse(bruto) : [];
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return [];
    }
  }

  function gravar(lista) {
    try {
      window.localStorage.setItem(CHAVE, JSON.stringify(lista));
    } catch (e) {
      /* Sem espaço ou sem permissão: segue em memória até fechar a aba. */
    }
    memoria = lista;
    avisar();
  }

  var memoria = ler();

  function itens() {
    return memoria;
  }

  function quantidadeTotal() {
    return memoria.reduce(function (soma, item) { return soma + item.q; }, 0);
  }

  /* ---------------- Operações ---------------- */

  function adicionar(dados) {
    var lista = itens();
    var existente = null;

    for (var i = 0; i < lista.length; i++) {
      if (lista[i].id === dados.id) { existente = lista[i]; break; }
    }

    if (existente) {
      /* Mesma variante clicada de novo é mais um do mesmo, não uma linha
         repetida: o vendedor não quer ler o mesmo item duas vezes. */
      existente.q = existente.q + 1;
    } else {
      if (lista.length >= LIMITE) return false;
      lista.push({ id: dados.id, p: dados.p, v: dados.v, u: dados.u, f: dados.f, q: 1 });
    }

    gravar(lista);
    return true;
  }

  function remover(id) {
    gravar(itens().filter(function (item) { return item.id !== id; }));
  }

  function alterarQuantidade(id, quantidade) {
    var lista = itens();
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].id === id) {
        lista[i].q = Math.max(1, Math.min(9999, quantidade || 1));
        break;
      }
    }
    gravar(lista);
  }

  function limpar() {
    gravar([]);
  }

  /* ---------------- Mensagem do WhatsApp ---------------- */

  /*
    Uma linha por item, numerada, com a medida separada do nome. É o formato
    que o vendedor consegue copiar direto para o orçamento sem reescrever.
  */
  function montarTexto(abertura) {
    var linhas = [abertura || 'Olá! Gostaria de um orçamento dos itens abaixo:', ''];

    itens().forEach(function (item, i) {
      var linha = (i + 1) + ') ' + item.p;
      if (item.v) linha += ' — ' + item.v;
      linha += ' — ' + item.q + ' un';
      linhas.push(linha);
    });

    return linhas.join('\n');
  }

  function linkWhatsApp(numero, abertura) {
    return 'https://wa.me/' + numero + '?text=' + encodeURIComponent(montarTexto(abertura));
  }

  /* ---------------- Avisos ---------------- */

  var ouvintes = [];

  function avisar() {
    ouvintes.forEach(function (fn) {
      try { fn(); } catch (e) {}
    });
  }

  /*
    Duas abas abertas na mesma loja compartilham o armazenamento. Sem isto,
    o cliente adiciona numa aba e a outra continua mostrando o contador
    antigo, o que parece bug mesmo não sendo.
  */
  window.addEventListener('storage', function (e) {
    if (e.key !== CHAVE) return;
    memoria = ler();
    avisar();
  });

  window.LZXOrcamento = {
    itens: itens,
    total: quantidadeTotal,
    adicionar: adicionar,
    remover: remover,
    quantidade: alterarQuantidade,
    limpar: limpar,
    texto: montarTexto,
    link: linkWhatsApp,
    aoMudar: function (fn) { ouvintes.push(fn); }
  };

  /* ---------------- Botões de adicionar ---------------- */

  function ligarBotoes(raiz) {
    raiz.querySelectorAll('[data-lzx-add]').forEach(function (botao) {
      if (botao.dataset.lzxReady) return;
      botao.dataset.lzxReady = '1';

      botao.addEventListener('click', function (e) {
        e.preventDefault();

        var ok = adicionar({
          id: botao.dataset.lzxId,
          p: botao.dataset.lzxProduto,
          v: botao.dataset.lzxVariante || '',
          u: botao.dataset.lzxUrl || '',
          f: botao.dataset.lzxImg || ''
        });

        /* Confirmação no próprio botão, e não um alerta: o cliente está
           navegando, e interromper para dizer "adicionado" é atrapalhar. */
        var rotulo = botao.querySelector('[data-lzx-add-label]');
        if (!rotulo) return;

        var original = botao.dataset.lzxLabelOriginal || rotulo.textContent;
        botao.dataset.lzxLabelOriginal = original;

        rotulo.textContent = ok ? 'Adicionado' : 'Lista cheia';
        botao.classList.add('is-added');

        clearTimeout(botao.lzxTempo);
        botao.lzxTempo = setTimeout(function () {
          rotulo.textContent = original;
          botao.classList.remove('is-added');
        }, 1600);
      });
    });
  }

  /* ---------------- Contador flutuante ---------------- */

  function ligarContador(raiz) {
    raiz.querySelectorAll('[data-lzx-contador]').forEach(function (chip) {
      if (chip.dataset.lzxReady) return;
      chip.dataset.lzxReady = '1';

      var numero = chip.querySelector('[data-lzx-contador-numero]');

      /*
        O botão continua na barra mesmo com a lista vazia: item de cabeçalho
        que aparece e some faz o resto da barra dançar, e o cliente precisa
        saber que a lista existe antes de ter o primeiro item nela. Some só o
        número, que sem itens não teria o que dizer.
      */
      function atualizar() {
        var n = quantidadeTotal();
        chip.classList.toggle('is-empty', n === 0);
        if (numero) numero.textContent = n;
      }

      aoMudarInterno(atualizar);
      atualizar();
    });
  }

  function aoMudarInterno(fn) {
    ouvintes.push(fn);
  }

  /* ---------------- Página do orçamento ---------------- */

  function ligarPagina(raiz) {
    raiz.querySelectorAll('[data-lzx-orcamento]').forEach(function (sec) {
      if (sec.dataset.lzxReady) return;
      sec.dataset.lzxReady = '1';

      var vazio = sec.querySelector('[data-lzx-orc-vazio]');
      var conteudo = sec.querySelector('[data-lzx-orc-conteudo]');
      var lista = sec.querySelector('[data-lzx-orc-lista]');
      var enviar = sec.querySelector('[data-lzx-orc-enviar]');
      var limparBtn = sec.querySelector('[data-lzx-orc-limpar]');
      var molde = document.querySelector('[data-lzx-orc-molde]');
      if (!lista || !molde) return;

      var numero = sec.dataset.lzxNumero;
      var abertura = sec.dataset.lzxAbertura;

      function desenhar() {
        var atuais = itens();

        vazio.hidden = atuais.length > 0;
        conteudo.hidden = atuais.length === 0;
        if (!atuais.length) return;

        lista.textContent = '';

        atuais.forEach(function (item) {
          var linha = molde.content.cloneNode(true);

          /* Listas montadas antes de a foto existir não têm o campo. Em vez
             de deixar um quadrado vazio, a miniatura simplesmente sai. */
          var foto = linha.querySelector('[data-campo="foto"]');
          if (item.f) {
            var img = foto.querySelector('img');
            img.src = item.f;
            img.alt = item.p;
            if (item.u) foto.setAttribute('href', item.u);
          } else {
            foto.remove();
          }

          var nome = linha.querySelector('[data-campo="nome"]');
          nome.textContent = item.p;
          if (item.u) nome.setAttribute('href', item.u);

          var medida = linha.querySelector('[data-campo="medida"]');
          if (item.v) medida.textContent = item.v;
          else medida.remove();

          var qtd = linha.querySelector('[data-campo="quantidade"]');
          qtd.value = item.q;
          qtd.addEventListener('change', function () {
            alterarQuantidade(item.id, parseInt(this.value, 10));
          });

          linha.querySelector('[data-campo="remover"]').addEventListener('click', function () {
            remover(item.id);
          });

          lista.appendChild(linha);
        });

        if (enviar && numero) enviar.setAttribute('href', linkWhatsApp(numero, abertura));
      }

      if (limparBtn) {
        limparBtn.addEventListener('click', function () {
          /* Apagar a lista inteira não tem como desfazer, e o cliente pode
             ter passado meia hora montando. Uma pergunta é barata. */
          if (window.confirm('Limpar a lista inteira?')) limpar();
        });
      }

      ouvintes.push(desenhar);
      desenhar();
    });
  }

  function iniciar(raiz) {
    ligarBotoes(raiz);
    ligarContador(raiz);
    ligarPagina(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
